import { jsx as m } from "react/jsx-runtime";
import { CUSTOM_HEADERS_COMPONENTS as C, CUSTOM_CELL_COMPONENTS as s } from "./index.es594.js";
import { useMemo as c } from "react";
import { BoxState as i } from "./index.es524.js";
import { useDataGridCellHovered as d } from "./index.es763.js";
import { BoxContextProvider as u } from "./index.es520.js";
const a = (t) => {
  const { children: e } = t, o = c(() => t.boxState ?? new i(), [t.boxState]), r = d(t.rowIndex, t.colDef.field);
  return o.hovered.set(r), /* @__PURE__ */ m(u, { boxState: o, children: e });
}, f = (t) => (e) => /* @__PURE__ */ m(a, { ...e, children: /* @__PURE__ */ m(t, { ...e }) }), M = ({
  headerComponent: t,
  cellType: e
}) => {
  let o;
  t && (o = Object.keys(t).filter((l) => l !== "testId")[0]);
  const r = C[o], n = s[e];
  return {
    HeaderComponent: r,
    CellComponent: n ? f(n) : void 0
  };
};
export {
  M as getCustomCellingComponents
};
//# sourceMappingURL=index.es757.js.map
